import React from 'react';
import { logError } from '../lib/log';

export class SceneBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(err) { logError('3D scene failed, showing fallback:', err); }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}

export default SceneBoundary;
